import { Injectable, NgModule } from '@angular/core';
import { CanActivate, Router, RouterModule } from '@angular/router';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = localStorage.getItem('access_token');
    // console.log('AuthGuard checking token:', token);
    // console.log('AuthGuard checking token expired:', this.isTokenExpired(token));
    if (!token || this.isTokenExpired(token)) {
      console.warn('🔐 Token missing or expired');
 Swal.fire({
      title: 'Login Failed',
      text: '🔐 Session missing or expired',
      icon: 'error',
      confirmButtonText: 'Login Again'
    });
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }

  private isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));

      if (!payload.exp) return true;

      const expiryTime = payload.exp * 1000; // JWT uses seconds, JS uses ms
      const now = Date.now();

      return now > expiryTime;
    } catch (err) {
      console.error('❌ Error parsing token', err);
      return true;
    }
  }
}
